<template>
  <div>
    <Head title="ការកំណត់" />
    <h1 class="moul flex items-center mb-8 text-2xl">
      <Link class="flex items-center text-indigo-400 hover:text-indigo-600" href="/loans"><CogIcon class="mr-2 w-8 h-8" /> ការកំណត់</Link>
      <span class="text-indigo-400 font-medium"><ChevronRightIcon class="w-5 h-5" /></span>{{ form.company_name_kh }}
    </h1>
    <div class="bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <div class="flex flex-wrap p-8">
          <div v-if="form.preview" class="mb-6 w-full"><img :src="form.preview" /></div>
          <text-input v-model="form.company_name_kh" :error="form.errors.company_name_kh" class="pb-8 pr-6 w-full lg:w-1/2" label="ឈ្មោះក្រុមហ៊ុនជាភាសាខ្មែរ *" />
          <text-input v-model="form.company_name_en" :error="form.errors.company_name_en" class="pb-8 pr-6 w-full lg:w-1/2" label="ឈ្មោះក្រុមហ៊ុនជាភាសាអង់គ្លេស *" />
          <text-input v-model="form.phone" :error="form.errors.phone" class="pb-8 pr-6 w-full lg:w-1/4" label="លេខទូរសព្ទ" />
          <text-input v-model="form.email" :error="form.errors.email" class="pb-8 pr-6 w-full lg:w-1/4" label="អ៊ីមែល" />
          <text-input v-model="form.representative_name" :error="form.errors.representative_name" class="pb-8 pr-6 w-full lg:w-1/4" label="ឈ្មោះអ្នកតំណាង *" />
          <file-input v-model="form.logo" :error="form.errors.logo" class="pb-8 pr-6 w-full lg:w-1/4" type="file" accept="image/*" label="ឡូហ្គោល" />
          <textarea-input rows="4" v-model="form.remarks" :error="form.errors.remarks" class="pb-8 pr-6 w-full lg:w-1/2" label="កំណត់ចំណាំលើតារាងបង់ប្រាក់ *" />
        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">រក្សាទុក</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import FileInput from '@/Shared/FileInput'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import TextareaInput from '@/Shared/TextareaInput'
import LoadingButton from '@/Shared/LoadingButton'
import { CogIcon, ChevronRightIcon } from '@heroicons/vue/24/outline'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    TextareaInput,
    CogIcon,
    ChevronRightIcon,
    FileInput,
  },
  layout: Layout,
  remember: 'form',
  props: {
    account: Object,
  },
  data() {
    return {
      form: this.$inertia.form({
        company_name_kh: this.account.company_name_kh,
        company_name_en: this.account.company_name_en,
        phone: this.account.phone,
        email: this.account.email,
        representative_name: this.account.representative_name,
        remarks: this.account.remarks,
        logo: null,
        preview: this.account.logo,
      }),
    }
  },
  methods: {
    store() {
      this.form.post('/settings')
    },
  },
}
</script>
